<template>
  <page :manualInit="busClsState.init" :manualErr="busClsState.initErr" @reload="doInit">
    <div v-if="renderBusClsType">
      <v-subheader>{{labels.reportType}}</v-subheader>
        <v-container fluid grid-list-lg class="mb-3">
          <v-layout row wrap>
            <v-flex lg2 md3 xs6 v-if="checkAccess(['motorRatingReview'])">
              <v-card :class="isMatchRoute('motorBusClsList') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="doProceedMotor">
                <v-layout fill-height column justify-center align-center>
                  <v-icon>{{appIcon.MOTOR}}</v-icon>
                  <span>Motor</span>
                </v-layout>
              </v-card>
            </v-flex>
            <v-flex lg2 md3 xs6 v-if="checkAccess(['travelRatingReview'])">
              <v-card :class="isMatchRoute('travelBusClsList') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="doProceedTravel">
                <v-layout fill-height column justify-center align-center>
                  <v-icon>{{appIcon.TRAVEL}}</v-icon>
                  <span>Travel</span>
                </v-layout>
              </v-card>
            </v-flex>
            <v-flex lg2 md3 xs6 v-if="checkAccess(['fireRatingReview'])">
              <v-card :class="isMatchRoute('fireBusClsList') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="doProceedFire">
                <v-layout fill-height column justify-center align-center>
                  <v-icon>{{appIcon.FIRE}}</v-icon>
                  <span>Fire</span>
                </v-layout>
              </v-card>
            </v-flex>
            <v-flex lg2 md3 xs6 v-if="checkAccess(['cargoRatingReview'])">
              <v-card :class="isMatchRoute('cargoBusClsList') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="doProceedCargo">
                <v-layout fill-height column justify-center align-center>
                  <v-icon>{{appIcon.CARGO}}</v-icon>
                  <span>Cargo</span>
                </v-layout>
              </v-card>
            </v-flex>
            <v-flex lg2 md3 xs6 v-if="checkAccess(['maidRatingReview'])">
              <v-card :class="isMatchRoute('maidBusClsList') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="doProceedMaid">
                <v-layout fill-height column justify-center align-center>
                  <v-icon>{{appIcon.MAID}}</v-icon>
                  <span>Maid</span>
                </v-layout>
              </v-card>
            </v-flex>
            <v-flex lg2 md3 xs6 v-if="checkAccess(['packageRatingReview'])">
              <v-card :class="isMatchRoute('packageBusClsList') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="doProceedPackage">
                <v-layout fill-height column justify-center align-center>
                  <v-icon>{{appIcon.PACKAGE}}</v-icon>
                  <span>Package</span>
                </v-layout>
              </v-card>
            </v-flex>
            <v-flex lg2 md3 xs6 v-if="checkAccess(['travelRatingReview'])">
              <v-card :class="isMatchRoute('paBusClsList') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="doProceedPA">
                <v-layout fill-height column justify-center align-center>
                  <v-icon>{{appIcon.PA}}</v-icon>
                  <span>Personal Accident</span>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
      <transition name="slide-x-transition" mode="out-in">
        <router-view></router-view>
      </transition>
  </page>
</template>

<script>
import routeMixin from '@/mixins/route'
import { appIcon } from '@/const/underwriting'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      labels: {
        reportType: 'Business Class Type'
      }
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    busClsState() {
      return this.$store.state.parameters.busCls
    },
    renderBusClsType() {
      if (this.isMatchRouteExact('busCls')) {
        return true
      } else {
        return false
      }
    },
    appIcon() {
      return appIcon
    }
  },
  methods: {
    doInit() {
      this.$store.dispatch('busClsInit')
    },
    doProceedMotor() {
      this.$router.push({ name: 'motorBusClsList' })
    },
    doProceedTravel() {
      this.$router.push({ name: 'travelBusClsList' })
    },
    doProceedCargo() {
      this.$router.push({ name: 'cargoBusClsList' })
    },
    doProceedFire() {
      this.$router.push({ name: 'fireBusClsList' })
    },
    doProceedMaid() {
      this.$router.push({ name: 'maidBusClsList' })
    },
    doProceedPackage() {
      this.$router.push({ name: 'packageBusClsList' })
    },
    doProceedPA() {
      this.$router.push({ name: 'paBusClsList' })
    }
  },
  mounted() {
    if (this.busClsState.init !== 1) {
      this.doInit()
    }
  },
  mixins: [
    routeMixin
  ]
}
</script>

<style lang="scss">
@import "../../../assets/scss/agency.scss"
</style>
